import {
  useAdPerformance,
  useFinancialSummary,
  useOtherCosts,
  useRevenueBreakdown
} from "../../apis";
import { FinancialComparison } from "../../constants";
import { LowMarginThresholdControl, PeriodToolbar } from "./atoms";
import {
  AdvertisingSection,
  CapitalSection,
  OtherCostsSection,
  ProfitLossSection,
  RevenueSection
} from "./sections";
import useFinancialPeriod from "./useFinancialPeriod";

import styles from "./ProfitAndLoss.module.scss";

const ProfitAndLoss = () => {
  const {
    preset,
    setPreset,
    range,
    customRange,
    setCustomRange,
    comparison,
    setComparison,
    customComparisonRange,
    setCustomComparisonRange,
    periodParams,
    revenueBreakdownParams
  } = useFinancialPeriod();

  const showComparison = comparison !== FinancialComparison.None;

  const { data: summary } = useFinancialSummary(periodParams);
  const { data: revenueBreakdown, isLoading: isRevenueBreakdownLoading } =
    useRevenueBreakdown(revenueBreakdownParams);
  const { data: otherCosts } = useOtherCosts(periodParams);
  const { data: adPerformance } = useAdPerformance(periodParams);

  return (
    <>
      <PeriodToolbar
        preset={preset}
        onPresetChange={setPreset}
        customRange={customRange}
        onCustomRangeChange={setCustomRange}
        comparison={comparison}
        onComparisonChange={setComparison}
        customComparisonRange={customComparisonRange}
        onCustomComparisonRangeChange={setCustomComparisonRange}
        window={revenueBreakdown?.window}
        comparisonWindow={revenueBreakdown?.comparisonWindow}
      />

      <div className={styles.sections}>
        <RevenueSection
          data={revenueBreakdown}
          isLoading={isRevenueBreakdownLoading}
          showComparison={showComparison}
          range={range}
          activeRangeType={preset}
        />

        <ProfitLossSection
          data={revenueBreakdown}
          summary={summary}
          isLoading={isRevenueBreakdownLoading}
          showComparison={showComparison}
          range={range}
          activeRangeType={preset}
        />

        <OtherCostsSection data={otherCosts} periodRevenue={summary?.revenue} />

        <CapitalSection data={revenueBreakdown} />

        <AdvertisingSection data={adPerformance} />

        <LowMarginThresholdControl />
      </div>
    </>
  );
};

export default ProfitAndLoss;
